<div class="grid" [ngClass]="{'warp-no-result':!isResult$()}">
    <que-manipulations-toolbar *ngIf="!isEmpty$()" [displaySlideToggleType]="'lists'"></que-manipulations-toolbar>
    <div *ngIf="isResult$() ; else thereIsNotResult">
        <que-saved-lists-header></que-saved-lists-header>
        <div class="scroll" [ngClass]="{'expanded':!isFilterListOpen$()}">
            <div *ngFor="let item of collectionLists$() ,let i =index">
                <que-list-collections-item [isLast]="i+1==collectionLists$()?.length"
                    [listCollectionItem]="item"></que-list-collections-item>
            </div>
            <ng-container *ngFor="let _ of [].constructor(3)">
                <div class="item-in-loading" *ngIf="loadingExtra$()"></div>
            </ng-container>
        </div>

    </div>
</div>



<ng-template #thereIsNotResult>
    <div class="grid no-result" *ngIf="!loading$() else loading">
        <que-no-result [isEmpty]="isEmpty$()" [type]="'savedList'"></que-no-result>
    </div>
</ng-template>
<ng-template #loading>
    <div class="no-result">
        <ng-container *ngFor="let _ of [].constructor(10)">
            <div class="item-in-loading load-enimation"></div>
        </ng-container>
    </div>
</ng-template>